import React from "react";
import ResourceManager from "../../components/admin/ResourceManager";

const ICON_OPTIONS = [
    "PenTool", "Palette", "Share2", "Monitor", "Package", "Lightbulb",
    "Square", "Printer", "Sparkles", "Wand2", "Briefcase", "Camera", "Brush", "Image",
];

const SERVICE_FIELDS = [
    { key: "id",          label: "Slug (unique id)", type: "text", required: true, placeholder: "logo-design", helpText: "Use lowercase-with-hyphens. Cannot be changed after creation in the public site (icon mapping uses this)." },
    { key: "title",       label: "Service Title",    type: "text", required: true, placeholder: "Logo Design" },
    { key: "description", label: "Description",      type: "textarea", required: true, rows: 3, placeholder: "Short tagline shown under the title." },
    { key: "icon",        label: "Icon",             type: "select", options: ICON_OPTIONS, helpText: "Lucide icon name." },
    { key: "position",    label: "Position",         type: "number" },
    { key: "visible",     label: "Visibility",       type: "switch", defaultValue: true },
];

// 'id' should not be edited after creation (public site keys icons by id).
const SERVICE_FIELDS_EDIT = SERVICE_FIELDS.filter((f) => f.key !== "id");

export const AdminServicesPage = () => (
    <ResourceManager
        resourceKey="services"
        title="Services Manager"
        singular="Service"
        description="Edit titles, descriptions and visibility of services shown across the site."
        endpoint="/admin/services"
        fields={SERVICE_FIELDS}
        editFields={SERVICE_FIELDS_EDIT}
        renderItem={(item) => (
            <div>
                <div className="flex items-center gap-3 mb-1">
                    <span className="inline-flex items-center font-inter text-[10px] uppercase tracking-[0.2em] text-gold bg-gold/10 border border-gold/20 px-2.5 py-1 rounded-full">
                        {item.icon}
                    </span>
                    <span className="font-inter text-xs text-zinc-500">/{item.id}</span>
                </div>
                <div className="font-poppins font-medium text-white">{item.title}</div>
                <p className="mt-1 font-inter text-sm text-zinc-400 line-clamp-2">{item.description}</p>
            </div>
        )}
    />
);

export default AdminServicesPage;
